const SCRIPT_ID = "medhop-aime-guide-knowledge";
const STOP_WORDS = new Set(["yang", "dan", "atau", "untuk", "dari", "pada", "dengan", "cara", "gimana", "bagaimana", "saya", "aku", "gue", "mau", "bisa", "tolong", "menu", "medhop", "aime"]);
const SYNONYMS = {
  antrian: ["antrean", "queue"], antrean: ["antrian", "queue"],
  daftar: ["registrasi", "pendaftaran"], registrasi: ["daftar", "pendaftaran"],
  bayar: ["pembayaran", "kasir", "invoice"], uang: ["finance", "keuangan", "kas"],
  obat: ["farmasi", "apotek", "resep"], stok: ["inventory", "inventori", "batch"],
  laporan: ["report", "analitik"], pegawai: ["karyawan", "sdm", "hr"],
  tutorial: ["panduan", "guide"], pasien: ["patient"], dokter: ["doctor"],
};

let loadingPromise = null;

function tokens(value) {
  const base = String(value || "").toLocaleLowerCase("id-ID").replace(/[^a-z0-9]+/g, " ").split(/\s+/)
    .filter(word => word.length > 1 && !STOP_WORDS.has(word));
  const expanded = [];
  base.forEach(word => {
    expanded.push(word);
    (SYNONYMS[word] || []).forEach(alias => expanded.push(alias));
  });
  return Array.from(new Set(expanded));
}

function appendGuideScript(resolve, reject) {
  const existing = document.getElementById(SCRIPT_ID);
  const script = existing || document.createElement("script");
  const done = () => window.MEDHOP_GUIDE ? resolve(window.MEDHOP_GUIDE) : reject(new Error("Knowledge User Guide tidak tersedia."));
  script.addEventListener("load", done, { once: true });
  script.addEventListener("error", () => reject(new Error("Knowledge User Guide gagal dimuat.")), { once: true });
  if (!existing) {
    script.id = SCRIPT_ID;
    script.src = "/guide/data.js";
    script.async = true;
    document.head.appendChild(script);
  }
}

export function loadAimeKnowledge() {
  if (window.MEDHOP_GUIDE) return Promise.resolve(window.MEDHOP_GUIDE);
  if (!loadingPromise) loadingPromise = new Promise(appendGuideScript).catch(error => {
    loadingPromise = null;
    throw error;
  });
  return loadingPromise;
}

function scoreText(query, queryTokens, fields) {
  const title = String(fields.title || "").toLocaleLowerCase("id-ID");
  const keywords = String(fields.keywords || "").toLocaleLowerCase("id-ID");
  const body = String(fields.body || "").toLocaleLowerCase("id-ID");
  let score = title === query ? 80 : (title.indexOf(query) !== -1 && query.length > 2 ? 24 : 0);
  queryTokens.forEach(token => {
    if (title.indexOf(token) !== -1) score += 9;
    if (keywords.indexOf(token) !== -1) score += 6;
    if (body.indexOf(token) !== -1) score += 2;
  });
  return score;
}

export function searchGuide(guide, question, limit = 3) {
  const query = String(question || "").trim().toLocaleLowerCase("id-ID");
  const queryTokens = tokens(query);
  const introductions = guide.introductions || {};
  const tips = guide.quickTips || {};
  const articles = (guide.articles || []).map(article => {
    const body = [article.audience, article.outcome, introductions[article.id], ...(article.steps || []), article.tip, article.watch, tips[article.id]].filter(Boolean).join(" ");
    return { ...article, type: "article", score: scoreText(query, queryTokens, { title: article.title, keywords: article.keywords, body }) };
  });
  const faqs = (guide.faqs || []).map((faq, index) => ({
    id: `faq-${index + 1}`, type: "faq", title: faq[0], answer: faq[1],
    score: scoreText(query, queryTokens, { title: faq[0], body: faq[1] }),
  }));
  return articles.concat(faqs).filter(item => item.score >= 4).sort((left, right) => right.score - left.score).slice(0, limit);
}

export function guideSource(guide, item) {
  return {
    id: item.id,
    label: item.type === "faq" ? "FAQ User Guide Medhop" : item.title,
    url: item.type === "faq" ? "/guide/index.html#faq" : `/guide/index.html#${item.id}`,
    kind: "user_guide",
    version: guide.version || "unversioned",
  };
}
